import React, { useState, useEffect } from "react";

import MenuItem from "./MenuItem";
import "../../style/menu.css";
import { fetchData } from "../api";

const Menu = () => {
const enableOnlineOrder = process.env.REACT_APP_ENABLE_ONLINE_ORDER === 'true';

  const [menuItems, setMenuItem] = useState([]);

  useEffect(() => {
    if (!enableOnlineOrder) return;

    const fetchItems = async () => {
      try {
        // Use /items/fast: returns menu data immediately without images.
        // Each MenuItem will lazy-load its own image when it scrolls into view.
        const response = await fetchData("/items/fast");
        if (!response.ok) {
          throw new Error("Request failed from Menu.js");
        }
        const data = await response;
        setMenuItem(data.items.filter((item) => item));
        return data;
      } catch (error) {
        console.error(error);
      }
    };

    fetchItems()
      .then((res) => {
        console.log("Res from useEffect", res);
      })
      .catch((error) => console.log(error));
  }, []);

  return (
    <div className='menu-page-wrapper'>
      {/* Modern Header */}
      <div className='menu-header'>
        <h1 className='menu-title'>Menu</h1>
        <h2 className='menu-subtitle'>メニュー</h2>
      </div>

      {/* Menu Items Grid */}
      {menuItems.length === 0 || !enableOnlineOrder ? (
        <div className='menu-empty'>
          <div className='menu-empty-icon'>🍽️</div>
          <div className='menu-empty-text'>No items available</div>
          <div className='menu-empty-subtext'>Check back soon for delicious options!</div>
        </div>
      ) : (
        <div className='menu-container'>
          {menuItems.map((item) => (
            <MenuItem
              className='menu-item'
              key={item.id}
              item={item}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Menu;
